<div class="oqs-animate-fade oqs-loading" ng-if="!quote.data.quoteDefinition">
  <div class="oqs-loading-container">
    <div class="oqs-loading-msg">Loading</div>
    <div class="progress">
      <div class="indeterminate"></div>
    </div>
  </div>
</div>

<div class="oqs-animate-fade" ng-if="quote.data.quoteDefinition">

  <oqs-top-panel
    oqs-logo-url="quote.data.quoteDefinition.sbuDetails.webLogoUrl"
    oqs-logo-link="quote.getSbuWebsite()"
    oqs-title-message-key="quote.heading.insuranceQuoteHeading"
    oqs-broker-logo-url="quote.data.selectedBroker.logoUrl"></oqs-top-panel>

  <div class="oqs-left-panel">

    <div class="oqs-navigation">
      <a ui-sref="summary" class="btn btn-block"
         ng-class="{'disabled btn-default': !quote.isForwardButtonEnabled(), 'btn-primary': quote.isForwardButtonEnabled()}">

        <div class="oqs-btn-icon">
          <span class="fa fa-chevron-circle-right fa-2x"></span>
        </div>
      <span class="oqs-btn-label" oqs-message="quote.button.viewQuoteDetailsButton">
        Next Step
      </span>
      </a>
    </div>

    <p ng-if="quote.data.quoteRequestInProgress" class="oqs-quote-spinner">
      <span class="fa fa-spinner fa-pulse"></span>
    </p>

    <div ng-if="quote.showQuoteResponse()" class="ng-animate oqs-quote-response oqs-animate-flip">
      <div ng-if="quote.getQuoteResponseType() === 'QUOTE_RESPONSE_SUCCESS'"
           class="oqs-quote-response-success">
      <span ng-if="quote.data.quoteResponse.data.messageList.length > 0">
        <p class="oqs-quote-response-message" ng-repeat="message in quote.data.quoteResponse.data.messageList"
           ng-bind-html="message.text | trustAsHtml"></p>
      </span>
      <span ng-if="quote.data.quoteResponse.data.showQuote">
        <span class="month">{{ quote.data.quoteResponse.data.monthlyPremium | currency }}<small>/month</small></span>
        <span class="year">{{ quote.data.quoteResponse.data.annualPremium | currency }}<small>/year</small></span>
      </span>
      </div>
      <div ng-if="quote.getQuoteResponseType() === 'QUOTE_RESPONSE_UNSUCCESSFUL'"
           class="oqs-quote-response-error">
        <span oqs-message="quote.html.quoteUnsuccessfulMessage" oqs-message-html></span>
      </div>
      <div ng-if="quote.getQuoteResponseType() === 'QUOTE_RESPONSE_ERROR'" class="oqs-quote-response-error">
        <div><span class="fa fa-exclamation-circle fa-3x"></span></div>
        <p oqs-message="quote.html.quoteErrorMessage" oqs-message-html></p>
      </div>
    </div>

    <div ng-if="!quote.quoteForm.$valid  && quote.data.viewModel.selectedQuoteType !== null" class="ng-animate oqs-quote-response oqs-animate-flip">
      <p class="oqs-quote-response-message"  oqs-message="quote.html.requiredQuestionsMessage" oqs-message-html></p>
    </div>

    <div class="oqs-company-snippet" oqs-message="global.html.companySnippet" oqs-message-html>
    </div>
  </div>

  <form class="oqs-right-panel" novalidate name="quote.quoteForm">
    <div class="oqs-section" ng-repeat="section in quote.data.viewModel.sectionList">
      <oqs-section oqs-section-model="section" oqs-validation-active="quote.validationActive"></oqs-section>
    </div>
    <div class="oqs-section">
      <div class="oqs-section-icon">
        <!-- TODO Add model type selection icon -->
        <span class="fa fa-file-o"></span>
      </div>
      <div class="oqs-section-questions row">
        <div class="col-xs-12">
          <div class="form-horizontal">
            <div class="oqs-question-group form-group">
              <label class="oqs-question-label control-label col-sm-4"
                     oqs-message="quote.label.policySectionLabel"></label>

              <div class="oqs-question-control col-sm-8">
                <div>
                  <div class="oqs-radio-buttons oqs-quote-type btn-group btn-group-justified">
                    <label class="btn btn-default" ng-repeat="quoteType in quote.data.viewModel.quoteTypeList"
                           ng-model="quote.data.viewModel.selectedQuoteType"
                           ng-change="quote.updateQuoteType(quoteType)"
                           uib-btn-radio="{{ quoteType }}">
                      <span class="fa" ng-class="quoteType.definition.attributes.icon"></span>
                      <span class="oqs-label" ng-bind="quoteType.definition.name"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="oqs-section" ng-repeat="section in quote.data.viewModel.selectedQuoteType.sectionList">
      <oqs-section oqs-section-model="section" oqs-validation-active="quote.validationActive"></oqs-section>
    </div>
    <div class="oqs-navigation" ng-if="quote.data.viewModel.selectedQuoteType.sectionList">
      <div>
        <a ui-sref="summary" class="btn btn-block"
           ng-class="{'disabled btn-default': !quote.isForwardButtonEnabled(), 'btn-primary': quote.isForwardButtonEnabled()}">
          <div class="oqs-btn-icon">
            <span class="fa fa-chevron-circle-right fa-2x"></span>
          </div>
       <span class="oqs-btn-label" oqs-message="quote.button.viewQuoteDetailsButton">
        Next Step
      </span>
        </a>
      </div>

    </div>
  </form>
</div>
